import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker (PWA) — production-only registration ideally, but
// CRA's dev server also serves /sw.js fine, so we register always in browsers
// that support it.
// Service worker disabled until users have cleared stale caches (booking /undefined/api bug).
// Re-enable after stable period by restoring registration below.
if (false && "serviceWorker" in navigator && window.location.protocol !== "file:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* SW registration is non-critical — fail silently */
    });
  });
}
